import { render } from "./PackageUp.vue?vue&type=template&id=6b1d3bb0"
import script from "./PackageUp.vue?vue&type=script&lang=js"
export * from "./PackageUp.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__